// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3Hs-8{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;background-color:#fff;padding:1.03125rem 1.5rem .96875rem 1rem;border-bottom:1px solid #dcdddd}._3Hs-8 h5{font-size:14px;font-weight:300;line-height:23px;font-family:var(--base-font)}@media(max-width:767px){._3Hs-8 h5{font-size:16px;line-height:26px}}._3dX21{cursor:pointer}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "_3Hs-8",
	"icon": "_3dX21"
};
module.exports = exports;
